import { Sparkles } from "lucide-react"

/**
 * Cortex identity avatar — 40×40px, rounded-xl (12px).
 * Fallback: Sparkles on violet glass. Future: shader asset (Unicorn Studio).
 */
export function CortexAvatar({ className = "" }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-center justify-center w-10 h-10 rounded-xl bg-violet-500/10 border border-violet-400/20 text-violet-400 shrink-0 ${className}`}
      aria-hidden
    >
      <Sparkles className="w-5 h-5" />
    </span>
  )
}
